<template>
  <div class="app-container">
    <!--表格-->
    <div class="table-container">
      <el-button size="mini"
                 type="primary"
                 @click="goToEdit()">创建网站</el-button>
      <table-box :data="tableData"
                 :tableHeight="tableHeight"
                 :expandAllFlag="expandAll"
                 id="rebateSetTable"
                 rowKey="_id"
                 ref="table">
        <table-column prop="name"
                      alignType="left"
                      label="名称"> </table-column>
        <table-column prop="catalog"
                      label="目录"> </table-column>
        <table-column label="模版">
          <template slot-scope="scope">
            <span v-if="!scope.row.is_page">{{getTemName(scope.row.template_id)}}</span>
          </template>
        </table-column>
        <table-column label="操作"
                      :width="'300px'"
                      alignType="left">
          <template slot-scope="scope">
            <span class="table-btn"
                  @click="websiteSet(scope.row)">设置</span>
            <span class="table-btn"
                  v-if="!scope.row.have_page"
                  @click="_detail(scope.row)">内容管理</span>
            <span class="table-btn"
                  v-if="!scope.row.have_page"
                  @click="_subjectDetail(scope.row)">栏目管理</span>
            <span class="table-btn"
                  v-if="!scope.row.is_page"
                  @click="build(scope.row)">生成</span>
            <span class="table-btn"
                  v-if="scope.row.built"
                  @click="_preview(scope.row)">查看</span>
            <span class="table-btn delete"
                  v-if="!scope.row.is_page"
                  @click="_delete(scope.row)">删除</span>
          </template>
        </table-column>
      </table-box>
      <!-- <pagination @currentChange="handleCurrentChange"
                  @sizeChange="handleSizeChange"
                  :currentPage.sync="searchForm.page"
                  :pageSize.sync="searchForm.per_page"
                  :total="total">
      </pagination> -->
    </div>
    <!--设置网站-->
    <pop-dialog title="设置网站"
                :showFlag.sync="editGames"
                showCloseFlag
                dialogType="form"
                @sureClick="addArt"
                @cancelClick="editGames = false;imgList = [];">
      <el-form :model="editGameForm"
               :label-width="formLabelWidth">
        <el-form-item label="官网名称">
          <el-input class="add_input"
                    size="mini"
                    v-model="editGameForm.name"
                    :disabled="editGameForm.is_page"></el-input>
        </el-form-item>
        <el-form-item label="选择模版">
          <el-select v-model="editGameForm.template_id"
                     placeholder="请选择"
                     size="mini"
                     :disabled="disabled">
            <el-option-group v-for="group in moduleList"
                             :key="group.label"
                             :label="group.label">
              <el-option v-for="item in group.options"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="所属">
          <el-select v-model="editGameForm.is_overSea"
                     placeholder="请选择"
                     size="mini"
                     @change="getParentWeb(editGameForm.is_overSea)"
                     disabled>
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父目录">
          <el-select v-model="editGameForm.parent_id"
                     clearable
                     size="mini"
                     placeholder="请选择"
                     @change="getCatalog(editGameForm.parent_id)"
                     :disabled="editGameForm.is_page">
            <el-option v-for="item in parentWebs"
                       :key="item._id"
                       :label="item.name"
                       :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="官网目录">
          <el-input class="add_input"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editGameForm.catalog"
                    :disabled="editGameForm.is_page"></el-input>
        </el-form-item>
        <el-form-item label="站点标题"
                      v-if='!editGameForm.have_page'>
          <el-input class="add_input"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editGameForm.title"></el-input>
        </el-form-item>
        <el-form-item label="关键词"
                      v-if='!editGameForm.have_page'>
          <el-input class="add_input"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editGameForm.keywords"></el-input>
        </el-form-item>
        <el-form-item label="描述"
                      v-if='!editGameForm.have_page'>
          <el-input class="add_input"
                    placeholder="请输入内容"
                    size="mini"
                    v-model="editGameForm.describe"></el-input>
        </el-form-item>
        <el-form-item label="地址栏图标"
                      v-if='!editGameForm.is_page'>
          <el-upload :action="imgUpload"
                     :class="{disabled:uploadDisabledImage}"
                     list-type="picture-card"
                     :on-preview="handlePictureCardPreview"
                     :on-success="handlePictureSuccess"
                     :on-remove="handleRemoveImage"
                     :before-upload="beforeAvatarUpload"
                     :file-list="imgList"
                     :headers="isOverSeaObj">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisibleImage">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
    </pop-dialog>
    <!-- <div class="btn">
      <el-button type="primary"
                 @click="goToEdit()">创建网站
      </el-button>
    </div> -->
    <!-- <h2>国内</h2>
    <tree-table :data="countryData"
                :expandAll="expandAll"
                border>
      <el-table-column label="名称"
                       width='150px'>
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="目录"
                       width='150px'>
        <template slot-scope="scope">
          <span>{{scope.row.catalog}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="_detail(scope.row)"
                     type="primary"
                     size="small"
                     v-if="!scope.row.have_page">内容管理
          </el-button>
          <el-button @click="_subjectDetail(scope.row)"
                     type="primary"
                     size="small"
                     v-if="!scope.row.have_page">栏目管理
          </el-button>
          <el-button @click="websiteSet(scope.row)"
                     size="small"
                     type="primary">设置
          </el-button>
          <el-button @click="_delete(scope.row)"
                     type="primary"
                     size="small"
                     v-if="!scope.row.is_page">删除
          </el-button>
          <el-button @click="build(scope.row)"
                     type="primary"
                     size="small"
                     v-if="!scope.row.is_page">生成
          </el-button>
          <el-button @click="_preview(scope.row)"
                     v-if="scope.row.built"
                     size="small"
                     type="primary">查看
          </el-button>
        </template>
      </el-table-column>
    </tree-table>
    <h2>国外</h2>
    <tree-table :data="overSeaData"
                :expandAll="expandAll"
                border>
      <el-table-column label="名称"
                       width='150px'>
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="目录"
                       width='150px'>
        <template slot-scope="scope">
          <span>{{scope.row.catalog}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="_detail(scope.row)"
                     type="primary"
                     v-if="!scope.row.have_page">内容管理
          </el-button>
          <el-button @click="_subjectDetail(scope.row)"
                     type="primary"
                     v-if="!scope.row.have_page">栏目管理
          </el-button>
          <el-button @click="websiteSet(scope.row)"
                     type="primary">设置
          </el-button>
          <el-button @click="_delete(scope.row)"
                     type="primary"
                     v-if="!scope.row.is_page">删除
          </el-button>
          <el-button @click="build(scope.row)"
                     type="primary"
                     v-if="!scope.row.is_page">生成
          </el-button>
          <el-button @click="_preview(scope.row)"
                     v-if="scope.row.built"
                     type="primary">查看
          </el-button>
        </template>
      </el-table-column>
    </tree-table> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
import api from '../api/api';


export default {
  name: 'WebsiteConfig',
  props: {
    tableData: {
      type: Array,
    },
    isOverseas: {
      type: Boolean,
    },
  },
  data() {
    return {
      expandAll: true,
      isFirst: true,
      editGames: false,
      loading2: true,
      disabled: false,
      uploadDisabledImage: false,
      dialogVisibleImage: false,
      imgUpload: `${api.url}upload`,
      formLabelWidth: '85px',
      imgList: [],
      temList: [],
      dialogImageUrl: '',
      catalogLink: '',
      selectCatalog: '',
      editGameForm: {},
      isOverSeaObj: {},
      options: [
        {
          value: true,
          label: '海外',
        },
        {
          value: false,
          label: '国内',
        },
      ],
      parentWebs: [],
      moduleList: [],
      timer: '',
      // loadingFlag: '',
      isBuild: false,
      buildCount: 0,
      count: '',
      isLock: false,
      tableHeight: 0,
    };
  },
  computed: {
    ...mapState([
      'columns',
      'activityList',
    ]),
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        document.documentElement.clientHeight - this.$refs.table.$el.offsetTop - 100;
    });
    this.isBuild = false;
    this.getModuleList();
    this.$store.dispatch('getInfo');
  },
  methods: {
    getModuleList() {
      axios
        .get(`${api.url}modulelist`)
        .then((response) => {
          if (response.data.ret === 0) {
            this.moduleList = response.data.content;
            if (this.moduleList[1].options) {
              this.moduleList[1].options.forEach((item) => {
                this.temList.push(item);
              });
            }
            if (this.moduleList[0].options) {
              this.moduleList[0].options.forEach((item) => {
                this.temList.push(item);
              });
            }
          }
        });
    },
    getModule(tid) {
      localStorage.setItem('templateId', tid);
      this.$store.commit('getTemplate', tid);
    },
    getTemName(tid) {
      const getItem = this.temList.find(tem => tem.id === tid);
      if (getItem) {
        return getItem.name;
      }
      return '';
    },
    handleRemoveImage() {
      this.uploadDisabledImage = false;
      this.editGameForm.favicon = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImage = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabledImage = true;
        this.editGameForm.favicon = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      // if (!this.editGameForm.is_overSea) {
      //   this.$message.error('请先选择所属~');
      // }
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isIcon = file.type === 'image/x-icon';
      if (!isJPG && !isPng && !isIcon) {
        this.$message.error('上传图片只能是 JPG 格式,ico 格式或者 PNG 格式!');
      }
    },
    getParentWeb(isOverSea) {
      const object = {};
      object.isOverSea = isOverSea;
      this.isOverSeaObj = object;
      this.getParentWebs('', isOverSea);
    },
    getCatalog(id) {
      const _ = this;
      _.selectCatalog = '';
      if (id !== '0') {
        const arr = this.parentWebs;
        for (let i = 0; i < arr.length; i += 1) {
          if (arr[i]._id === id) {
            _.selectCatalog = arr[i].catalogLink;
            break;
          }
        }
      }
    },
    // 修改设置
    addArt() {
      // 英文和数字组合判断的正则表达式
      const regp = /^([a-zA-Z]*?)((?:[0-9]+(?:[0-9]|[a-zA-Z])*)*)$/;
      if (this.editGameForm.name === '') {
        this.$message({
          message: '请填写官网名称',
          type: 'warning',
        });
        return;
      }
      if (this.editGameForm.is_overSea === '') {
        this.$message({
          message: '请选择所属海内外',
          type: 'warning',
        });
        return;
      }
      if (this.editGameForm.catalog === '') {
        this.$message({
          message: '请填写官网目录~',
          type: 'warning',
        });
        return;
      }
      if (this.editGameForm.title === '') {
        this.$message({
          message: '请填写站点标题~',
          type: 'warning',
        });
        return;
      }
      if (this.editGameForm.keywords === '') {
        this.$message({
          message: '请填写关键词~',
          type: 'warning',
        });
        return;
      }
      if (this.editGameForm.describe === '') {
        this.$message({
          message: '请填写网站描述~',
          type: 'warning',
        });
        return;
      }
      if (this.favicon === '') {
        this.$message({
          message: '请上传地址栏图标~',
          type: 'warning',
        });
        return;
      }
      if (!regp.test(this.editGameForm.catalog)) {
        this.$message({
          message: '官网目录只能包括英文和数字~',
          type: 'warning',
        });
        return;
      }
      const data = {
        title: this.editGameForm.title,
        keywords: this.editGameForm.keywords,
        describe: this.editGameForm.describe,
        wid: this.$store.state.websiteId,
        webSiteChildIds: this.webSiteChildIds,
        name: this.editGameForm.name,
        catalog: this.editGameForm.catalog,
        favicon: this.editGameForm.favicon,
        parent_id: this.editGameForm.parent_id,
        template_id: this.editGameForm.template_id,
        is_overSea: this.editGameForm.is_overSea,
        catalogLink: `${this.selectCatalog}/${this.editGameForm.catalog}`,
      };
      axios.post(`${api.url}webSet`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$message({
            message: '操作成功～',
            type: 'success',
          });
          this.$store.dispatch('getInfo');
          this.imgList = [];
          this.editGames = false;
        } else if (response.data.ret === 1) {
          this.$message({
            message: response.data.msg,
            type: 'error',
          });
        }
      });
    },
    getInfo() {
      const that = this;
      axios
        .get(`${api.url}list`)
        .then((response) => {
          const data = response.data;
          if (data.ret === 0) {
            if (this.isOverseas) {
              this.tableData = data.content.overSeaData;
            } else {
              this.tableData = data.content.countryData;
            }
            this.$store.commit('user_name', data.content.user.real_name);
            localStorage.setItem('user_name', data.content.user.real_name);
            that.loadingFlag = false;
          }
        })
        .catch(() => {
          that.loadingFlag = false;
        });
    },
    // 连接socket
    connect() {
      // 开始连接socket
      if (!this.$socket.connected) {
        this.$socket.open();
        this.sockets.subscribe('server', (data) => {
          this.$store.commit('getNotificationMessage', data);
          switch (data.type) {
            case 'begin':
              this.$message({
                message: data.msg,
                type: 'warning',
              });
              // this.loading.close();
              break;
            case 'success':
              this.$message({
                message: data.msg,
                type: 'success',
              });
              this.$store.dispatch('getInfo');
              break;
            case 'fail':
              this.$message({
                message: data.msg,
                type: 'error',
              });
              // this.loading.close();
              break;
            case 'wait':
              this.$message({
                message: data.msg,
                type: 'warning',
              });
              // this.loading.close();
              break;
            case 'building':
              this.$message({
                message: data.msg,
                type: 'warning',
              });
              // this.loading.close();
              break;
            default:
              break;
          }
        });
      }
    },

    // 发送消息
    sendMessage(msg) {
      this.$socket.emit('server', msg);
    },

    _detail(data) {
      const wName = data.name;
      const wid = data._id;
      const _ = this;
      _.$store.commit('getWebSiteName', wName);
      localStorage.setItem('webSiteName', wName);
      _.$store.commit('getWebSite', wid);
      localStorage.setItem('webSite', wid);
      _.$store.commit('getColumnId', '');
      localStorage.setItem('columnId', '');
      localStorage.setItem('is_overSea', data.is_overSea);
      this.$store.commit('getPublicUrl', data.is_overSea);
      _.$router.push({
        path: 'websiteDetail',
      });
    },
    _subjectDetail(data) {
      const wName = data.name;
      const wid = data._id;
      const tid = data.template_id;
      localStorage.setItem('is_overSea', data.is_overSea);
      this.$store.commit('getPublicUrl', data.is_overSea);
      const _ = this;
      axios.get(`${api.url}validationData`, {
        params: {
          wid,
          tid,
          name: wName,
        },
      }).then((response) => {
        const validationData = response.data;
        if (validationData.ret === 0) {
          _.$confirm('检测到模板已经进行过更改，如果继续编辑的话，网站生成后可能有所改变，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            let loading = '';
            loading = _.$loading({
              lock: true,
              text: '更新中。。。',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            });
            axios.get(`${api.url}transferData`, {
              params: {
                wid,
                tid,
                name: wName,
              },
            }).then((res) => {
              loading.close();
              const transferData = res.data;
              if (transferData.ret === 0) {
                _.$store.commit('getWebSiteName', wName);
                this.$store.commit('setNavName', '栏目编辑');
                localStorage.setItem('webSiteName', wName);
                localStorage.setItem('navName', '栏目编辑');
                _.$store.commit('getWebSite', wid);
                localStorage.setItem('webSite', wid);
                _.$router.push({
                  path: 'ColumnDetail',
                });
              } else if (transferData.ret === 3) {
                _.$message({
                  message: transferData.msg,
                  type: 'warning',
                });
              }
            });
          });
        } else if (validationData.ret === 3) {
          _.$store.commit('getWebSiteName', wName);
          this.$store.commit('setNavName', '栏目编辑');
          localStorage.setItem('webSiteName', wName);
          localStorage.setItem('navName', '栏目编辑');
          _.$store.commit('getWebSite', wid);
          localStorage.setItem('webSite', wid);
          _.$router.push({
            path: 'ColumnDetail',
          });
        }
      });
    },
    getParentWebs(id, isOverSea) {
      axios
        .post(`${api.url}getParentWeb`, { wid: id, is_overSea: isOverSea })
        .then((response) => {
          if (response.data.ret === 0) {
            this.parentWebs = response.data.content;
            this.parentWebs.unshift({ _id: '0', name: '首级' });
            for (let i = 0; i < this.parentWebs.length; i += 1) {
              if (this.parentWebs[i]._id === this.parent_id) {
                this.selectCatalog = this.parentWebs[i].catalogLink;
                break;
              }
            }
          }
        });
    },
    websiteSet(data) {
      this.imgList = [];
      this.disabled = true;
      const wid = data._id;
      const tid = data.template_id;
      const _ = this;
      const arr = [];
      localStorage.setItem('is_overSea', data.is_overSea);
      this.$store.commit('getPublicUrl', data.is_overSea);
      data.children.forEach((item) => {
        if (item.is_page) {
          arr.push(item._id);
        }
      });
      this.selectCatalog = '';
      this.webSiteChildIds = arr;
      _.$store.commit('getWebSite', wid);
      localStorage.setItem('webSite', wid);
      localStorage.setItem('templateId', tid);
      _.$store.commit('getTemplate', tid);
      this.editGames = true;
      const object = {};
      object.isOverSea = data.is_overSea;
      this.isOverSeaObj = object;
      this.editGameForm = data;
      if (this.editGameForm.favicon) {
        this.favicon = this.editGameForm.favicon;
        this.imgList = [{ url: this.$store.state.publicUrl + this.editGameForm.favicon }];
        this.uploadDisabledImage = true;
      }
      this.getParentWebs(wid, data.is_overSea);
    },
    goToEdit() {
      this.imgList = [];
      localStorage.setItem('webSite', '');
      this.$store.commit('getWebSite', '');
      this.disabled = false;
      this.editGameForm = {
        is_overSea: this.isOverseas,
      };
      this.template_id = this.$store.state.template_id;
      this.uploadDisabledImage = false;
      this.editGames = true;
      console.log(this.editGameForm);
      this.getParentWebs('', this.isOverseas);
      // location.href = '#/template';
    },
    build(item) {
      const that = this;
      const tid = item.template_id;
      const wid = item._id;
      if (!this.isBuild) {
        this.isBuild = true;
        // 判断该网站下面是否有内容页，如果有才会去检测内容页是否有增加或者减少
        if (item.have_page) {
          axios.get(`${api.url}validationPage`, {
            params: {
              wid,
              tid,
            },
          }).then((response) => {
            const data = response.data;
            if (data.ret === 0) {
              that.$confirm('检测到模板的内容页已经进行过更改，需要先对该模板进行更新，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                let loading = '';
                loading = that.$loading({
                  lock: true,
                  text: '更新中。。。',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
                });
                axios.get(`${api.url}transferPage`, {
                  params: {
                    wid,
                    tid,
                  },
                }).then((res) => {
                  loading.close();
                  const transferPage = res.data;
                  if (transferPage.ret === 0) {
                    that.$message({
                      message: '已更新完成~',
                      type: 'success',
                    });
                    location.reload();
                  }
                });
              });
            } else if (data.ret === 3) {
              that.buildFn(item);
            }
          });
        } else {
          that.buildFn(item);
        }
      }
    },
    buildFn(item) {
      const info = item;
      info.built = false;
      if (this.isFirst) {
        this.connect();
        this.isFirst = false;
      }

      // const that = this;
      // // 该模板没有进行过任何修改
      // this.loading = that.$loading({
      //   lock: true,
      //   text: '打包中。。。',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // });
      const childCatalog = [];
      item.children.forEach((json) => {
        if (!json.is_page) {
          childCatalog.push(json.catalog);
        }
      });
      this.sendMessage({
        id: item._id,
        name: item.name,
        template_id: item.template_id,
        catalogLink: item.catalogLink,
        is_overSea: item.is_overSea,
        childCatalog,
      });

      this.isBuild = false;
      // axios
      //   .post(`${api.url}buildWeb`, {
      //     id: item._id,
      //     template_id: item.template_id,
      //     catalogLink: item.catalogLink,
      //     is_overSea: item.is_overSea,
      //     childCatalog,
      //   })
      //   .then((response) => {
      //     if (response.data.ret === 0) {
      //       // this.buildCount = 0;
      //       // that.getState(item);
      //       that.loading.close();
      //       that.$message({
      //         message: '后台打包中，请稍后再查看～',
      //         type: 'warning',
      //       });
      //     } else if (response.data.ret === 3) {
      //       that.loading.close();
      //       that.$message({
      //         message: response.data.content,
      //         type: 'warning',
      //       });
      //     } else if (response.data.ret === 1) {
      //       that.loading.close();
      //       that.$message({
      //         message: response.data.content,
      //         type: 'error',
      //       });
      //     } else if (response.data.ret === -1) {
      //       that.loading.close();
      //       that.$message({
      //         message: '单点登录超时~,请重新打包',
      //         type: 'error',
      //       });
      //     } else if (response.data.ret === 4) {
      //       that.loading.close();
      //       that.$message({
      //         message: response.data.content,
      //         type: 'error',
      //       });
      //     }
      //   });
    },
    isPreview(data) {
      this.count += 1;
      const that = this;
      if (!this.isLock) {
        this.isLock = true;
        axios
          .get(`${api.url}preview`, {
            params: {
              catalogLink: data.catalogLink,
              template_id: data.template_id,
            },
          })
          .then((response) => {
            const myData = response.data;
            that.isLock = false;
            if (myData.ret === 0) {
              that.loading2.close();
              window.open(myData.url);
            } else if (myData.ret === -2) {
              if (that.count <= 3) {
                setTimeout(() => {
                  that.isPreview(data);
                }, 3000);
              } else {
                that.loading2.close();
                that.$message({
                  message: '请先生成该网站',
                  type: 'error',
                });
              }
            }
          });
      }
    },
    _preview(data) {
      this.loading2 = this.$loading({
        lock: true,
        text: '拼命找寻文件中，请稍候。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.count = 0;
      this.isLock = false;
      this.isPreview(data);
    },
    _delete(data) {
      if (data.have_page === false && data.children.length > 0) {
        this.$message({
          message: '该网站有子集，不允许直接删除，如果想要删除，请先删除子集~',
          type: 'error',
        });
        return;
      }
      if (data.have_page === true) {
        const arr = data.children.filter(item => !item.is_page);
        if (arr.length > 0) {
          this.$message({
            message: '该网站有子集，不允许直接删除，如果想要删除，请先删除子集~',
            type: 'error',
          });
          return;
        }
      }
      const id = data._id;
      this.$confirm('此操作将永久删除该网站, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        axios
          .get(`${api.url}deleteWeb`, {
            params: {
              id,
            },
          })
          .then((response) => {
            const webData = response.data;
            if (webData.ret === 0) {
              this.$message({
                message: '删除成功~',
                type: 'success',
              });
              window.location.reload();
            }
          });
      });
    },
  },
};
</script>

<style scoped lang="less">
h2 {
  line-height: 50px;
}
.disabled {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/WebsiteConfig.vue